/**
 * Singleton to hold context props for the environment the app is running in
 * Note: requires window.env.ENV object to be set in the browser
 * @returns {object}
 */
class Env {
  constructor() {
    if (!Env.instance) {
      const isClient = typeof window !== 'undefined';
      const env = (isClient && window.env && window.env.ENV) || {};

      Env.instance = {
        isClient,
        isClientLocal: isClient && env === 'local',
        isClientDev: isClient && env === 'dev',
        isClientTest: isClient && env === 'test',
        isClientProd: isClient && env === 'prod',
        isClientNonProd:
          isClient && (env === 'local' || env === 'dev' || env === 'test'),
      };
    }

    return Env.instance;
  }
}

export default new Env();
